import PvpBattleScreen from '../components/pvp/PvpBattleScreen';
import PvpHub from '../components/pvp/PvpHub';

export default [
  {
    name: 'PvpHub',
    path: '/pvp',
    component: PvpHub,
  },
  {
    name: 'PvpRankedHub',
    path: '/pvp/ranked',
    component: PvpHub,
    props: {initialTab: 'ranked'},
  },
  {
    name: 'PvpBattleScreen',
    path: '/pvp/:id',
    component: PvpBattleScreen,
    props: true,
  },
]
